import { Alert, AlertTitle } from '@mui/material'

import { useTexts } from '../useTexts'

export function TrackingLinkFailed() {
  const texts = useTexts()

  return (
    <Alert severity="error">
      <AlertTitle>{texts.trackingLinkFailureTitle}</AlertTitle>
      {texts.trackingLinkFailureDescription}
    </Alert>
  )
}
